/* Kurf LP — gallery, qty, FAQ, reveal, and Horizon-native Ajax add-to-cart.
   Loaded as type="module" so it can dynamically import the theme's @shopify/events. */

(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function themeRoutes() {
    var addUrl = '/cart/add.js';
    var cartBase = '/cart';
    try {
      if (typeof Theme !== 'undefined' && Theme && Theme.routes) {
        if (Theme.routes.cart_add_url) addUrl = Theme.routes.cart_add_url; // already ends in .js
        if (Theme.routes.cart_url) cartBase = Theme.routes.cart_url;
      }
    } catch (e) {}
    return { addUrl: addUrl, cartBase: cartBase };
  }

  /* ---------- gallery (scroll-snap carousel + thumbnail strip) ---------- */
  function initGallery(root) {
    var track = root.querySelector('[data-klp-track]');
    var thumbsWrap = root.querySelector('.klp-offer-thumbs');
    var thumbs = root.querySelectorAll('[data-klp-thumb]');
    if (!track || !thumbs.length) return;
    var slides = track.querySelectorAll('[data-klp-slide]');

    // Keep the active thumbnail in view inside the horizontally scrollable strip.
    function ensureThumbVisible(t) {
      if (!thumbsWrap) return;
      var cl = thumbsWrap.scrollLeft, cr = cl + thumbsWrap.clientWidth;
      var tl = t.offsetLeft, tr = tl + t.offsetWidth;
      if (tl < cl) thumbsWrap.scrollTo({ left: Math.max(0, tl - 8), behavior: 'smooth' });
      else if (tr > cr) thumbsWrap.scrollTo({ left: tr - thumbsWrap.clientWidth + 8, behavior: 'smooth' });
    }

    function setActive(i) {
      for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.remove('is-active');
      if (thumbs[i]) { thumbs[i].classList.add('is-active'); ensureThumbVisible(thumbs[i]); }
    }

    // Slides are exactly one track-width wide with no gap, so index math is direct.
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setActive(i);
      });
    });

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var w = Math.max(1, track.clientWidth);
        var idx = Math.round(track.scrollLeft / w);
        idx = Math.max(0, Math.min(slides.length - 1, idx));
        setActive(idx);
      });
    }, { passive: true });
  }

  /* ---------- bundle picker ---------- */
  function initBundles(root) {
    var bundles = root.querySelectorAll('[data-klp-bundle]');
    if (!bundles.length) return;
    var btn = root.querySelector('[data-klp-add]');
    var priceEl = root.querySelector('[data-klp-cta-price]');

    function select(el) {
      bundles.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-checked', 'false');
        var input = b.querySelector('.klp-bundle-input');
        if (input) input.checked = false;
      });
      el.classList.add('is-active');
      el.setAttribute('aria-checked', 'true');
      var input = el.querySelector('.klp-bundle-input');
      if (input) input.checked = true;
      var vid = el.getAttribute('data-variant-id');
      var total = el.getAttribute('data-total');
      if (btn && vid) btn.setAttribute('data-variant-id', vid);
      if (priceEl && total) priceEl.textContent = total;
    }

    bundles.forEach(function (el) {
      el.addEventListener('click', function () { select(el); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); select(el); }
      });
    });
  }

  /* ---------- quantity ---------- */
  function initQty(root) {
    var wrap = root.querySelector('[data-klp-qty]');
    if (!wrap) return { get: function () { return 1; } };
    var input = wrap.querySelector('[data-klp-qty-input]');
    var dec = wrap.querySelector('[data-klp-qty-dec]');
    var inc = wrap.querySelector('[data-klp-qty-inc]');
    function val() { return Math.max(1, parseInt(input.value, 10) || 1); }
    function set(n) { input.value = String(Math.max(1, Math.min(99, n))); }
    if (dec) dec.addEventListener('click', function () { set(val() - 1); });
    if (inc) inc.addEventListener('click', function () { set(val() + 1); });
    return { get: val };
  }

  /* ---------- open Horizon cart drawer (public API) ---------- */
  function openCartDrawer() {
    try {
      var cdc = document.querySelector('cart-drawer-component');
      var drawer = cdc && cdc.closest ? cdc.closest('theme-drawer') : null;
      if (!drawer) drawer = document.querySelector('theme-drawer[data-cart], cart-drawer, #cart-drawer');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); return true; }
    } catch (e) {}
    return false;
  }

  /* ---------- refresh drawer contents via native event ---------- */
  function collectCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      if (c.dataset && c.dataset.sectionId && ids.indexOf(c.dataset.sectionId) === -1) {
        ids.push(c.dataset.sectionId);
      }
    });
    return ids;
  }

  async function addToCart(variantId, qty, btn) {
    var routes = themeRoutes();
    var cartUrl = (btn && btn.getAttribute('data-cart-url')) || routes.cartBase || '/cart';

    var sectionIds = collectCartSectionIds();
    var body = new FormData();
    body.append('id', String(variantId));
    body.append('quantity', String(qty));
    if (sectionIds.length) {
      body.append('sections', sectionIds.join(','));
      body.append('sections_url', window.location.pathname);
    }

    // Native Horizon integration (best effort): announce the update so the
    // cart drawer + bubble react. Falls back gracefully if unavailable.
    var events = null, deferred = null;
    try { events = await import('@shopify/events'); } catch (e) { events = null; }
    if (events && events.CartLinesUpdateEvent) {
      try {
        deferred = events.CartLinesUpdateEvent.createPromise();
        document.dispatchEvent(new events.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(variantId), quantity: qty }],
          promise: deferred.promise
        }));
      } catch (e) { deferred = null; }
    }

    var res, data;
    try {
      res = await fetch(routes.addUrl, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body,
        credentials: 'same-origin'
      });
      data = await res.json();
    } catch (e) {
      if (deferred) { try { deferred.reject(e); } catch (_) {} }
      throw new Error('Netwerkfout. Probeer opnieuw.');
    }

    if (!res.ok || data.status) {
      if (deferred) { try { deferred.reject(new Error(data && data.message)); } catch (_) {} }
      throw new Error((data && (data.description || data.message)) || 'Kon niet toevoegen aan winkelmand.');
    }

    // Resolve the deferred so cart-items-component morphs + bubble updates.
    if (deferred && events && events.CartLinesUpdateEvent) {
      try {
        var ajaxCart = await fetch(routes.cartBase + '.js', {
          headers: { Accept: 'application/json' }, credentials: 'same-origin'
        }).then(function (r) { return r.json(); });
        deferred.resolve({
          cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
          detail: {
            items: ajaxCart.items,
            sections: data.sections,
            source: 'kurf-lp',
            sourceId: 'kurf-lp',
            itemCount: qty
          }
        });
      } catch (e) {
        try { deferred.resolve({ detail: { sections: data.sections, source: 'kurf-lp', sourceId: 'kurf-lp', itemCount: qty } }); } catch (_) {}
      }
    }

    // Open the drawer; if the theme has none, send the shopper to the cart page.
    var opened = openCartDrawer();
    if (!opened) {
      setTimeout(function () { window.location.href = cartUrl; }, 350);
    }
    return true;
  }

  function initAdd(root) {
    var qty = initQty(root);
    var btn = root.querySelector('[data-klp-add]');
    if (!btn) return;
    var elDefault = btn.querySelector('[data-klp-cta-default]');
    var elLoading = btn.querySelector('[data-klp-cta-loading]');
    var elSuccess = btn.querySelector('[data-klp-cta-success]');
    var err = root.querySelector('[data-klp-add-err]');

    function state(name) {
      if (elDefault) elDefault.hidden = name !== 'default';
      if (elLoading) elLoading.hidden = name !== 'loading';
      if (elSuccess) elSuccess.hidden = name !== 'success';
    }

    btn.addEventListener('click', async function () {
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      if (err) { err.hidden = true; err.textContent = ''; }
      btn.setAttribute('disabled', 'disabled');
      state('loading');
      try {
        await addToCart(variantId, qty.get(), btn);
        state('success');
        setTimeout(function () { state('default'); btn.removeAttribute('disabled'); }, 2500);
      } catch (e) {
        state('default');
        btn.removeAttribute('disabled');
        if (err) { err.hidden = false; err.textContent = e.message || 'Er ging iets mis.'; }
      }
    });
  }

  /* ---------- smooth scroll for in-page anchors ---------- */
  function initAnchors() {
    document.querySelectorAll('a[href^="#klp"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href');
        var target = id && id.length > 1 ? document.querySelector(id) : null;
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.klp-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('klp-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('klp-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- boot ---------- */
  function boot() {
    var offer = document.getElementById('klp-offer');
    if (offer) { initGallery(offer); initBundles(offer); initAdd(offer); }
    initAnchors();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
